import React, { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "../theme";

// Branded loading splash — only shown when landing on / navigating to the home page.
const HOME_PATHS = ["/", "/home"];

const RouteTransition = () => {
  const { pathname } = useLocation();
  const { theme } = useTheme();
  const logo = theme !== "venom" ? "/gv-logo-onyx.png" : "/gv-logo.png";
  const [loading, setLoading] = useState(() => HOME_PATHS.includes(pathname));

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    if (!HOME_PATHS.includes(pathname)) { setLoading(false); return; }
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(t);
  }, [pathname]);

  // Leaving Home must unmount the splash even if its timer was cancelled.
  if (!HOME_PATHS.includes(pathname)) return null;

  return (
    <div
      data-testid="home-route-overlay"
      data-loading={loading}
      aria-hidden="true"
      className={`pointer-events-none fixed inset-0 z-[45] flex items-center justify-center overflow-hidden bg-[#080b14] transition-opacity duration-500 ease-in-out ${
        loading ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="pointer-events-none absolute inset-0 splash-grid" />
      {loading && (
        <img
          src={logo}
          alt="GVRewards"
          className="relative h-12 sm:h-14 w-auto logo-glow logo-loading"
        />
      )}
    </div>
  );
};

export default RouteTransition;
